<template>
    <div class="page" :class="pageClass">
        <router-view/>
    </div>
    <div v-if="loading" class="notify _opened">
        <div class="notify__loader loader"></div>
        <div v-if="loadingMessage.length > 0" class="notify__text">{{loadingMessage}}</div>
        <div v-else class="notify__text">Авторизация...</div>
    </div>
</template>


<script>

    let socket = null;

    export default {
        props: ['instance'],
        data: function(){
            let data = {
                loadingMessage:'',
                loading:false,
                pageClass:'',
            };
            return data;
        } ,

        watch: {
            user: function(val, oldVal) {
                let vm = this;
                if('id' in val && val.id > 0){
                    //console.log("connect");
                    //console.log(process.env.VUE_APP_HOST);
                    //let socket = new WebSocket("wss://" + process.env.VUE_APP_HOST);
                    //socket = new WebSocket("wss://javascript.info/article/websocket/demo/hello");
                    socket = new WebSocket("wss://app.getmaterial.ru/api/v1/ws");
                    socket.onopen = () => console.log ('connection: WebSocket connection success!');
                    socket.onclose =  () => console.log ('Disconnect: WebSocket connection is closed!');
                    socket.onerror =  () => console.log ('Error: WebSocket connection is error!');
                    socket.onmessage = function(data){ vm.$store.dispatch("onSocket", data);}

                    setTimeout(function(){
                        let message = {
                            "message": "HI",
                            "data":{
                                "name": "ALEX"
                            }
                        };
                        socket.send(JSON.stringify(message));
                    }, 3000);
                }
            }
        },
        computed: {
            user: function () {
                return this.$store.getters.getUser;
            },
        },
        mounted:function () {
            let vm = this;
            vm.$store.dispatch("fetchStart");
        },
        created() {

        },
        methods: {
            isAuthorized: function(){
                return this.user.id > 0 ? true : false;
            },

        },
        beforeDestroy(){
            socket.close();
            socket = null
        }
    }
</script>